const ROUTE_VIEW_HEALTH = [
   //健康信息
  { path: '/health_massage_auth', name: '健康信息授权', h5Uri: '/health/health_massage_auth', nativeUri: null, whiteList: false }
  ]
  
export default ROUTE_VIEW_HEALTH



// WEBPACK FOOTER //
// ./src/router/mapping/health.js